export default __webpack_public_path__ + "assets/bbc9c8.svg";